//-------------------------------------------------------------------------------------------------- Imports
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getPaymentsHasDebt } from "../../methods/Methods";

//-------------------------------------------------------------------------------------------------- Interfaces
interface CheckDebtSliceInterface {
    clientId: string;
}

interface DebtSliceStateInterface {
    hasDebt: boolean;
}

//-------------------------------------------------------------------------------------------------- Vars and consts
const initialDebtState = {
    hasDebt: false,
} as DebtSliceStateInterface;



//-------------------------------------------------------------------------------------------------- Thunks

const checkDebt = createAsyncThunk(
    "thunk/setDebt",
    async (objectData: CheckDebtSliceInterface): Promise<DebtSliceStateInterface> => {
        const data: DebtSliceStateInterface = {
            hasDebt: false,
        };
        
        await getPaymentsHasDebt(objectData.clientId)
            .then((response) => {
                if (response.data && response.data.data && response.data.data[0]) {
                    data.hasDebt = response.data.data[0].hasDebt;
                }
            })
            .catch(() => {
            });

        return data;
    }
);


//-------------------------------------------------------------------------------------------------- Slice
const debtSlice = createSlice({
    name: "checkDebtData",
    initialState: initialDebtState,
    reducers: {
        setDebtData: (state, action: PayloadAction<DebtSliceStateInterface>) => {
            state.hasDebt = action.payload.hasDebt;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(checkDebt.fulfilled, (state, action) => {
            state.hasDebt = action.payload.hasDebt;
        });
    },
});

//-------------------------------------------------------------------------------------------------- Exports
export {checkDebt};
export const { setDebtData } = debtSlice.actions;
export const getDebtState = (state: any) => state.checkDebtData as DebtSliceStateInterface;
export default debtSlice.reducer;
